import type { ApiListingMiniExtra } from '#/api/types/ApiListingMini';
import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  listings: ApiListingMiniExtra[];
};

function mapResponse(response: ApiResponse): ApiListingMiniExtra[] {
  return response.listings;
}

const endpoint = new FetchEndpoint({
  urlFactory: (
    orgId: ApiOrgId,
    listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT',
    page: number,
  ) =>
    `/data/website/organizations/${orgId}/listings?listingType=${listingType}&page=${page}`,
  mapResponse,
});

// Exports

export const listingApiFetchOrgListings = endpoint.createClientFetchFn();

export const listingApiIsomorphicFetchOrgListings =
  endpoint.createIsomorphicFetchFn();
